import { ChevronLeft, ChevronRight } from 'lucide-react';
import { CalendarView, getPeriodTitle } from '@/lib/calendar';

interface CalendarHeaderProps {
  currentDate: Date;
  view: CalendarView;
  onNavigatePrevious: () => void;
  onNavigateNext: () => void;
  onViewChange: (view: CalendarView) => void;
  onToday: () => void;
}

export function CalendarHeader({
  currentDate,
  view,
  onNavigatePrevious,
  onNavigateNext,
  onViewChange,
  onToday,
}: CalendarHeaderProps) {
  const viewButtons: { value: CalendarView; label: string }[] = [
    { value: 'month', label: '月' },
    { value: 'week', label: '週' },
    { value: 'day', label: '日' },
  ];

  return (
    <div className="bg-white rounded-xl shadow-md p-4 mb-6">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        {/* 左側: ナビゲーション */}
        <div className="flex items-center gap-4">
          <button
            onClick={onToday}
            className="px-4 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-200 font-medium shadow-md hover:shadow-lg"
          >
            今日
          </button>
          
          <div className="flex items-center gap-2">
            <button
              onClick={onNavigatePrevious}
              className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
              aria-label="前へ"
            >
              <ChevronLeft className="w-5 h-5 text-gray-600" />
            </button>
            
            <h2 className="text-xl font-bold text-gray-800 min-w-[200px] text-center">
              {getPeriodTitle(currentDate, view)}
            </h2>
            
            <button
              onClick={onNavigateNext}
              className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
              aria-label="次へ"
            >
              <ChevronRight className="w-5 h-5 text-gray-600" />
            </button>
          </div>
        </div>

        {/* 右側: ビュー切替 */}
        <div className="flex items-center gap-2 bg-gray-100 p-1 rounded-lg">
          {viewButtons.map((btn) => (
            <button
              key={btn.value}
              onClick={() => onViewChange(btn.value)}
              className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
                view === btn.value
                  ? 'bg-white text-blue-600 shadow-md'
                  : 'text-gray-600 hover:text-gray-800'
              }`}
            >
              {btn.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
